import { USAGE_TYPE } from "../../../types/bookings";

export const isCommercialUsageType = (usageType?: string): boolean => {
  if (!usageType) return false;
  return usageType.toLowerCase() === USAGE_TYPE.COMMERCIAL;
};